import DashboardCard from "./DashboardCard";
const Dashboard={
     DashboardCard
}
export default Dashboard